import React from 'react';
import 'tippy.js/dist/tippy.css';
import { faX } from '@fortawesome/free-solid-svg-icons';
import IconButtonFontawesome from './IconButtonFontawesome';

const XButton = ({ show = true, onClick, tooltip }) => {
  return (
    <>
      <IconButtonFontawesome
        variant="outline-primary"
        size="sm"
        className=""
        role="button"
        icon={faX}
        tooltip={tooltip || 'Usuń'}
        onClick={onClick}
      />
    </>
  );
};

export default XButton;
